<template>
  <portal to="popup">
    <div class="popup-streak animate__animated animate__bounceIn">
      <div
        class="visualize-bg"
      >
        <div class="visualize-bg-holder">
          <img
            src="@/assets/images/visualize-items/sunburst.svg"
            alt=""
          >
        </div>
      </div>
      <div class="container">
        <div
          class="close"
          @click="$emit('showPopup', false)"
        >
          <i class="fas fa-times" />
        </div>
        <div class="content-placeholder">
          <div class="bonus-badge-wrp">
            <transition
              enter-active-class="animate__animated animate__bounceIn"
              leave-active-class="animate__animated animate__fadeOutDown"
            >
              <div
                v-if="isActiveStreakBonus && isShowBonusBadge"
                class="streak-bonus"
                :class="[`tier-${bonusTier}`]"
              >
                <span>{{ `+${streakBonus}` }}</span>
              </div>
            </transition>
          </div>

          <div
            class="point"
            :class="{
              'bonus': isStreakBonusAdded,
              'visible': point > 0
            }"
          >
            <span
              :class="{
                'animate__animated animate__bigPulse': showFinalAnimationEffect
              }"
            >
              {{ `+${point}` }}
            </span>
          </div>
          <div class="marker">
            <div class="marker-box">
              <img
                :src="require('@/assets/images/visualize-items/correct-large.png')"
                alt="badge"
                width="192"
                height="204"
              >
              <span class="marker-number">
                {{ `x${streak}` }}
              </span>
            </div>
          </div>
          <div class="lead">
            {{ quizResultText }}
          </div>
          <div class="info">
            {{ quizResultDesc }}
          </div>
          <div class="pill">
            {{ $t('💪 Keep up the great work!') }}
          </div>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    streak: {
      type: Number,
      default: 0,
    },
    point: {
      type: Number,
      default: 0,
    },
    streakBonus: {
      type: Number,
      default: 0,
    },
    isActiveStreakBonus: {
      type: Boolean,
      default: true,
    },
    isShowBonusBadge: {
      type: Boolean,
      default: false,
    },
    isStreakBonusAdded: {
      type: Boolean,
      default: true,
    },
    bonusTier: {
      type: Number,
      default: 1,
    },
    quizResultText: {
      type: String,
      default: '',
    },
    quizResultDesc: {
      type: String,
      default: '',
    },
    showFinalAnimationEffect: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
%edges {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

%flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-streak {
  position: fixed;
  @extend %edges;
  z-index: 9999;
  background-color: #15A962;
  overflow: hidden;
}

.bonus-badge-wrp {
  min-height: 36px;
}

.visualize-bg {
  position: absolute;
  @extend %edges;

  &-holder {
    display: inline-block;
    width: 300%;
    height: 300%;
    position: absolute;
    left: 50%;
    top: -115%;
    transform: translateX(-50%);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    animation: spin 10s linear infinite;
    margin-top: 60px;
  }
}

.close {
  @extend %flex-center;
  position: absolute;
  top: 25px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(10, 10, 10, 0.2);
  color: #fff;
  font-size: 24px;
  z-index: 1;
  cursor: pointer;
}

.container {
  position: relative;
  padding: 50px 18px 0 18px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: 992px) {
    padding-left: 60px;
    padding-right: 60px;
  }
}

.content-placeholder {
  text-align: center;
  color: #fff;

  .lead {
    font-size: 32px;
    font-weight: 700;
  }

  .info {
    margin-top: 8px;
    font-size: 18px;
    line-height: normal;
  }

  .pill {
    margin-top: 15px;
    font-size: 18px;
    font-weight: 700;
    line-height: normal;
    padding: 16px;
    background-color: rgba(10, 10, 10, 0.4);
    backdrop-filter: blur(12px);
    border-radius: 42px;
    width: 100%;
  }
}

.marker {
  margin-top: 16px;
  margin-bottom: 16px;

  &-box {
    position: relative;
    display: inline-block;
  }

  &-number {
    @extend %flex-center;
    font-size: 20px;
    line-height: normal;
    font-weight: 700;
    color: #1E6F48;
    background-color: #fff;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 57px;
    height: 57px;
    border: 5px solid #107F49;
    border-radius: 50%;
  }

  img {
    width: 152px;
    height: auto;
  }
}

.point {
  @extend %flex-center;
  font-size: 36px;
  font-weight: 700;
  min-height: 54px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  color: #fff;

  &.bonus {
    color: #FFE795;
  }
  &.visible {
    opacity: 1;
    visibility: visible;
  }
}

.streak-bonus {
  min-width: 68px;
  display: inline-block;
  padding: 6px;
  border-radius: 49px;
  background: #FFF;
  box-shadow: 0px 0px 6.133333206176758px 0px rgba(51, 193, 115, 0.60);

  span {
    font-size: 18px;
    font-weight: 800;
    color: #606060;
  }
}

@media screen and (min-width: 576px) {
  .container {
    padding-top: 70px;
  }

  .bonus-badge-wrp {
    min-height: 66px;
  }

  .visualize-bg {
    &-holder {
      top: -120%;
    }
  }

  .streak-bonus {
    min-width: 86px;
    padding: 6px 12px;

    span {
      font-size: 21px;
      line-height: 34px;
    }
  }

  .marker {
    margin-top: 30px;
    margin-bottom: 30px;

    &-number {
      @extend %flex-center;
      font-size: 24px;
      line-height: normal;
      font-weight: 700;
      color: #1E6F48;
      background-color: #fff;
      position: absolute;
      right: 0;
      bottom: 0;
      width: 57px;
      height: 57px;
      border: 5px solid #107F49;
      border-radius: 50%;
    }
  }

  .point {
    font-size: 40px;
    line-height: 54px;
  }

  .content-placeholder {
    .lead {
      font-size: 40px;
      line-height: 54px;
    }

    .info {
      margin-top: 8px;
      font-size: 20px;
    }

    .pill {
      margin-top: 23px;
      font-size: 20px;
      padding: 24px;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
